import React, { useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import InventoryCarCardRevamp from "../inventory-car-card-revamp";
import Slider from "react-slick";
import OurLocationModal from "../our-location-modal";

const MoreCarsRevamp = ({title, carList = [], config, isMoreCars}) => {
    const [showLocationModal, setShowLocationModal] = useState(false);

    const settings = {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: false,
        afterChange: () => {}
    };

    const onClickCallback = () => {
    };
    return (
        <React.Fragment>
            <div styleName={"styles.sliderWrapper styles.similarCarsWrapper"}>
                <h3>{title}</h3>
                <Slider {...settings}>
                    {carList.map((item, index) => (
                        <InventoryCarCardRevamp
                            onClickCallback = {onClickCallback}
                            config={config}
                            gtmFrom="home_page"
                            defaultTootlipStyle="styles.top"
                            index={index}
                            item={item}
                            egcRenderType="details"
                            bodyType={item.body || item.bodyType}
                            showLocationCallback={() => setShowLocationModal(true)}
                            ampProperty={{"cdp source": isMoreCars ? "similar car" : "more models"}}
                            {...({...item, emiDetails: item.emiDetails || {}}) } />
                    ))}
                </Slider>
                {showLocationModal && <OurLocationModal handleModalClose={() => setShowLocationModal(false)} />}
            </div>
        </React.Fragment>
    );
};

MoreCarsRevamp.propTypes = {
    title: PropTypes.string,
    carList: PropTypes.array,
    config: PropTypes.object,
    isMoreCars: PropTypes.bool,
    isCdpRevamp: PropTypes.bool
};

export default MoreCarsRevamp;
